/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListCimdClientPresetsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListCimdClientPresetsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListCimdClientPresetsSecurity = {
  option1?: ListCimdClientPresetsSecurityOption1 | undefined;
  option2?: ListCimdClientPresetsSecurityOption2 | undefined;
};

export type ListCimdClientPresetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListCimdClientPresetsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListCimdClientPresetsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListCimdClientPresetsSecurityOption1$Outbound,
  ListCimdClientPresetsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listCimdClientPresetsSecurityOption1ToJSON(
  listCimdClientPresetsSecurityOption1: ListCimdClientPresetsSecurityOption1,
): string {
  return JSON.stringify(
    ListCimdClientPresetsSecurityOption1$outboundSchema.parse(
      listCimdClientPresetsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListCimdClientPresetsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListCimdClientPresetsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListCimdClientPresetsSecurityOption2$Outbound,
  ListCimdClientPresetsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listCimdClientPresetsSecurityOption2ToJSON(
  listCimdClientPresetsSecurityOption2: ListCimdClientPresetsSecurityOption2,
): string {
  return JSON.stringify(
    ListCimdClientPresetsSecurityOption2$outboundSchema.parse(
      listCimdClientPresetsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListCimdClientPresetsSecurity$Outbound = {
  Option1?: ListCimdClientPresetsSecurityOption1$Outbound | undefined;
  Option2?: ListCimdClientPresetsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListCimdClientPresetsSecurity$outboundSchema: z.ZodMiniType<
  ListCimdClientPresetsSecurity$Outbound,
  ListCimdClientPresetsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListCimdClientPresetsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListCimdClientPresetsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listCimdClientPresetsSecurityToJSON(
  listCimdClientPresetsSecurity: ListCimdClientPresetsSecurity,
): string {
  return JSON.stringify(
    ListCimdClientPresetsSecurity$outboundSchema.parse(
      listCimdClientPresetsSecurity,
    ),
  );
}

/** @internal */
export type ListCimdClientPresetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListCimdClientPresetsRequest$outboundSchema: z.ZodMiniType<
  ListCimdClientPresetsRequest$Outbound,
  ListCimdClientPresetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listCimdClientPresetsRequestToJSON(
  listCimdClientPresetsRequest: ListCimdClientPresetsRequest,
): string {
  return JSON.stringify(
    ListCimdClientPresetsRequest$outboundSchema.parse(
      listCimdClientPresetsRequest,
    ),
  );
}
